// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const APIVersion = "v38";
const production = true;
const LiveServer = "https://portal.payar.co.uk";
const StageServer = "https://stage.toodleweb.app";
// const StageServer = "http://192.168.1.192:8000";
export const environment = {
  production: production,
  APIServer: production ? LiveServer : StageServer,
  API_URL: `${production ? LiveServer : StageServer}/api/${APIVersion}/`,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
